import { TRANSACTION_FITLER } from "../../../types/types";

/**
 * Sets the start date for the filter.
 * 
 * @param days amount of days to subtract from the current date.
 * @returns 
 */
export const setDateFilter = (maxDays: number) => {
  let date = new Date(new Date().setUTCHours(0, 0, 0, 0));
  date.setDate(date.getDate() - maxDays);
  return date;
}

/**
 * Get the date range and ensure it is within 31 days.
 * 
 * @param startDate 
 * @param endDate 
 * @returns 
 */
export const ensureDateRangeWithin31Days = (startDate: Date, endDate: Date, numbOfDays: number): [Date, Date] => {
  const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
  const thirtyOneDaysInMilliseconds = numbOfDays * oneDayInMilliseconds;

  const differenceInMilliseconds = Math.abs(endDate.getTime() - startDate.getTime());

  if (differenceInMilliseconds > thirtyOneDaysInMilliseconds) {
    // If the range is more than 31 days, adjust the end date to be 31 days after the start date
    const newEndDate = new Date(startDate.getTime() + thirtyOneDaysInMilliseconds);
    return [startDate, newEndDate];
  } else {
    // If the range is within 31 days, return the dates as they are
    return [startDate, endDate];
  }
}